import styled from 'styled-components';

const StyledError = styled.div<{ margin?: string }>`
  background-color: ${(props) => props.theme.primary};
  font-size: 14px;
  color: ${(props) => props.theme.white};
  display: inline-block;
  padding: 3px 12px;
  margin: ${(props) => (props.margin ? props.margin : 'auto')};
`;

export default StyledError;
